import LineItemConfig from "./LineItemConfig";
/**
 * LineControlConfig
 *  Encapsulates line control configuration settings.
 * */
var LineControlConfig = /** @class */ (function () {
    /**
     * Create a new line control configuration.
     * @param showRowTotals Set to show line item specific totals.
     * @param showColumnTotals Set to show column specific totals.
     * @param showActions Set to enable line control actions such as line item addition and deletion.
     * @param factory LineItem factory method used to create new line items. Required when showActions is true.
     * @param maxRows Maximum number of rows allowed in the line control.
     */
    function LineControlConfig(showRowTotals, showColumnTotals, showActions, factory, maxRows, columnTotal) {
        if (showRowTotals === void 0) { showRowTotals = false; }
        if (showColumnTotals === void 0) { showColumnTotals = true; }
        if (showActions === void 0) { showActions = false; }
        if (factory === void 0) { factory = null; }
        if (maxRows === void 0) { maxRows = null; }
        if (columnTotal === void 0) { columnTotal = null; }
        this._lineItemConfigurations = [];
        this._showRowTotals = showRowTotals;
        this._showColumnTotals = showColumnTotals;
        this._showActions = showActions;
        if (showActions && !factory) {
            throw new Error("LineControlConfig failed to initialise: line item factory must be provided when enabling actions.");
        }
        this._lineItemFactory = factory;
        if (columnTotal) {
            this._columnTotalFn = columnTotal;
        }
        else {
            this._columnTotalFn = function (items) {
                if (!items || items.length == 0)
                    return 0;
                return items.map(function (item) {
                    var value = item.amount;
                    return Number.isInteger(value) ? value : 0;
                }).reduce(function (prev, next) { return prev + next; });
            };
        }
        this._maxRows = maxRows;
    }
    Object.defineProperty(LineControlConfig.prototype, "showRowTotals", {
        get: function () {
            return this._showRowTotals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControlConfig.prototype, "showColumnTotals", {
        get: function () {
            return this._showColumnTotals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControlConfig.prototype, "showActions", {
        get: function () {
            return this._showActions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControlConfig.prototype, "lineItemFactory", {
        get: function () {
            return this._lineItemFactory;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControlConfig.prototype, "columnTotalFn", {
        get: function () {
            return this._columnTotalFn;
        },
        set: function (computation) {
            this._columnTotalFn = computation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControlConfig.prototype, "maxRows", {
        get: function () {
            return this._maxRows;
        },
        enumerable: false,
        configurable: true
    });
    LineControlConfig.prototype.addLineItemConfig = function (lineItemKey, config) {
        this._lineItemConfigurations.push({
            lineItemKey: lineItemKey,
            config: config
        });
    };
    LineControlConfig.prototype.getLineItemConfigOrDefault = function (lineItemKey) {
        var config = this._lineItemConfigurations
            .find(function (value) { return value.lineItemKey == lineItemKey; });
        return config
            ? config.config
            : new LineItemConfig(null);
    };
    LineControlConfig.prototype.getOrCreateLineItemConfig = function (lineItemKey) {
        var entry = this._lineItemConfigurations
            .find(function (value) { return value.lineItemKey == lineItemKey; });
        if (entry) {
            return entry.config;
        }
        else {
            var config = new LineItemConfig();
            this.addLineItemConfig(lineItemKey, config);
            return config;
        }
    };
    return LineControlConfig;
}());
export default LineControlConfig;
